module.exports = __webpack_public_path__ + "static/media/left_arrow.b01e3f3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/left_arrow.svg
// module id = 599
// module chunks = 20